export default __webpack_public_path__ + "static/media/msac.d303c930.png";